module.exports = {
  title: 'React Native Spiral Animation 🌀',
  author: 'Enzo Manuel Mangano',
  date: '2022-12-21',
  slug: 'spiral',
  tags: ['skia'],
};
